export class ResetPasswordResponseDTO{
    message: string = ''

    constructor(data: ResetPasswordResponseDTO){
        Object.assign(this, data);
    }
}